<template>
  <div class="lock">
    <img class="lock-img" src="@/assets/img/policy/lock.png"/>
    <p>{{ $t('permissionTip') }}</p>
    <p>{{ $t('permissionContact') }}</p>
  </div>
</template>

<script>
    export default {
        name: "Lock"
    }
</script>
